import $ from 'jquery'
export default function () {
	$('.sp-toggle').on('click', function () {
		$('.sp-toggle,.sp-nav').toggleClass('open');
	});
};